import { ScoreThreshold, getScoreThreshold } from '../../../constants/scoreThresholds';

/** Re-export the canonical threshold lookup for use inside this feature. */
export { getScoreThreshold as getScoreColor };
export type { ScoreThreshold as ScoreColorInfo };

/** Map section names to display icons */
export const SECTION_ICONS: Record<string, string> = {
    'Profile Summary': '👤',
    'Work Experience': '💼',
    'Project Experience': '🚀',
    'Certifications': '🏅',
    'Education': '🎓',
    'Languages': '🌐',
};

export const getSectionIcon = (sectionName: string): string =>
    SECTION_ICONS[sectionName] ?? '📋';
